import { createApp } from './main';

async function main() {
    const parseJSONScript = (id) => JSON.parse(document.getElementById(id)?.textContent || '{}');
    const initialState = parseJSONScript('app-state');
    const context = initialState.context;

    const { app, router, store } = createApp(context); // pass initialState.context
    store.replaceState(initialState);

    await router.isReady();
    app.mount('#app', true);
}

main();
